module.exports = __webpack_public_path__ + "img/sadface.f1b9e097.png";